import { Component } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@ionic/angular";
export class NoChatComponent {
}
NoChatComponent.ɵfac = function NoChatComponent_Factory(t) { return new (t || NoChatComponent)(); };
NoChatComponent.ɵcmp = i0.ɵɵdefineComponent({ type: NoChatComponent, selectors: [["app-no-chat"]], decls: 6, vars: 0, consts: [[1, "full-width"], [1, "full-height", "ion-justify-content-center", "ion-align-items-center"], [1, "ion-text-center"]], template: function NoChatComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ion-grid", 0);
        i0.ɵɵelementStart(1, "ion-row", 1);
        i0.ɵɵelementStart(2, "ion-col");
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelementStart(4, "h3");
        i0.ɵɵtext(5, "No chat selected");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } }, directives: [i1.IonGrid, i1.IonRow, i1.IonCol], encapsulation: 2 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(NoChatComponent, [{
        type: Component,
        args: [{
                selector: 'app-no-chat',
                template: `
    <ion-grid class="full-width">
      <ion-row class="full-height ion-justify-content-center ion-align-items-center">
        <ion-col>
          <div class="ion-text-center">
            <h3>No chat selected</h3>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  `,
                styles: [],
            }]
    }], null, null); })();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm8tY2hhdC5jb21wb25lbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi9hcHBzL21lc3Nlbmdlci9zcmMvYXBwL21vZHVsZXMvY2hhdC9jb21wb25lbnRzL25vLWNoYXQvbm8tY2hhdC5jb21wb25lbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGVBQWUsQ0FBQzs7O0FBaUIxQyxNQUFNLE9BQU8sZUFBZTs7OEVBQWYsZUFBZTtvREFBZixlQUFlO1FBWnhCLG1DQUNFO1FBQUEsa0NBQ0U7UUFBQSwrQkFDRTtRQUFBLDhCQUNFO1FBQUEsMEJBQUk7UUFBQSxnQ0FBZ0I7UUFBQSxpQkFBSztRQUMzQixpQkFBTTtRQUNSLGlCQUFVO1FBQ1osaUJBQVU7UUFDWixpQkFBVzs7a0RBSUYsZUFBZTtjQWYzQixTQUFTO2VBQUM7Z0JBQ1QsUUFBUSxFQUFFLGFBQWE7Z0JBQ3ZCLFFBQVEsRUFBRTs7Ozs7Ozs7OztHQVVUO2dCQUNELE1BQU0sRUFBRSxFQUFFO2FBQ1giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBDb21wb25lbnQgfSBmcm9tICdAYW5ndWxhci9jb3JlJztcblxuQENvbXBvbmVudCh7XG4gIHNlbGVjdG9yOiAnYXBwLW5vLWNoYXQnLFxuICB0ZW1wbGF0ZTogYFxuICAgIDxpb24tZ3JpZCBjbGFzcz1cImZ1bGwtd2lkdGhcIj5cbiAgICAgIDxpb24tcm93IGNsYXNzPVwiZnVsbC1oZWlnaHQgaW9uLWp1c3RpZnktY29udGVudC1jZW50ZXIgaW9uLWFsaWduLWl0ZW1zLWNlbnRlclwiPlxuICAgICAgICA8aW9uLWNvbD5cbiAgICAgICAgICA8ZGl2IGNsYXNzPVwiaW9uLXRleHQtY2VudGVyXCI+XG4gICAgICAgICAgICA8aDM+Tm8gY2hhdCBzZWxlY3RlZDwvaDM+XG4gICAgICAgICAgPC9kaXY+XG4gICAgICAgIDwvaW9uLWNvbD5cbiAgICAgIDwvaW9uLXJvdz5cbiAgICA8L2lvbi1ncmlkPlxuICBgLFxuICBzdHlsZXM6IFtdLFxufSlcbmV4cG9ydCBjbGFzcyBOb0NoYXRDb21wb25lbnQge1xuXG59XG4iXX0=